import { Injectable } from '@angular/core';
import { AngularFireDatabase, FirebaseObjectObservable } from 'angularfire2/database-deprecated';

import { AuthService } from '../../core/auth.service';
import { JoinServiceBase } from '../../shared/base/join-service-base';

@Injectable()
export class CourseUserService extends JoinServiceBase {
  constructor(db: AngularFireDatabase, private auth: AuthService) {
    super(db, '/course-users', '/users');
  }

  readEnrollment({ $key }) {
    return super.readChildAsObject($key).map(enrollments => enrollments[this.auth.uid]);
  }

  readUser({ $key }): FirebaseObjectObservable<any> {
    if (!this.auth.isAuthenticated) {
      throw new Error();
    }

    return super.readRef($key, this.auth.uid);
  }

  addUser({ $key }) {
    if (!this.auth.isAuthenticated) {
      throw new Error();
    }

    return this.addRef($key, this.auth.uid);
  }

  addRef(key: string, refKey: string) {
    return this.readRef(key, refKey).set({
      state: false
    });
  }
}



// WEBPACK FOOTER //
// /Users/JunnieJobs/git/nextstep-fe2/src/app/courses/shared/course-user.service.ts